module.exports = __webpack_public_path__ + "img/mz_logo.8451a7bd.png";